module.exports = __webpack_public_path__ + "img/manage-data-5.824f4bb5.jpg";